import React from 'react';
//import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import Back1 from '../assets/images/back-home-1.webp';
import SEO from '../components/SEO';
import CardEmisionPage from '../pages/CardEmisionPage';
import { useTranslation } from 'react-i18next';

export const CardEmision = () => {
  const { t, i18n } = useTranslation();

  return (
    <Layout backgroundimage={Back1} actionDemo={false}>
      <SEO
        title={t("Emisión de Tarjetas de Débito o Crédito")}
        description={t('Facilitamos la emisión de tarjetas Visa y Mastercard para ofrecer a tus clientes productos financieros seguros y rápidos.')}
        works={[
          t('Core Financiero'),
          t('Fintech'),
          t('Onboarding digital'),
          t('Aprobación de crédito'),
          t('Gestión de cobranza'),
          t('Análisis de crédito'),
          t('Core Bancario'),
          t('Automatización de procesos'),
          t('Procesos digitales'),
          t('Producto financiero'),
          t('Servicios financieros'),
          t('Digitalización de procesos'),
          t('Software financiero'),
          t('Dispersión'),
          t('Reportes automatizados'),
          t('Corebanking'),
          t('Sector financiero'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
          t('Condusef'),
          t('Servicios financieros digitales'),
          t('Plataforma financiera'),
        ]}
        bolImage={false}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        canonicalUrl={`https://dynamicore.io/${i18n.language === 'en' ? 'en/card-issuance' : 'emision-tarjetas'}`}
        hreflang={[
          { url: "https://dynamicore.io/emision-tarjetas", lang: "es" },
          { url: "https://dynamicore.io/en/card-issuance", lang: "en-us" }
        ]}
      />
      <CardEmisionPage/>
    </Layout>
  )
}
